module.exports = 'hmTouchEvents';

var angular = require('angular');
Hammer = require('hammerjs');
require('./angular.hammer')



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-hammer/index.js
 ** module id = 15
 ** module chunks = 0
 **/